import { getStandardSyncerFields } from '../common/syncUp';
let counter = 0;
export const dutyItemItemFields = `
    id
    userId
    state
    editableByUserIds
    deleted
    type
    startDate
    endDate
    forceRestAfter
    sectorCount
    startPlaceIcao
    endPlaceIcao
    blockTimeMinutes
    flightLegIds
    logbookRecordIds
    linkedDutyItemIds
    plannedFdpExtension
    travelToAccommodationMinutes
    note
    _version
`;
export const attachedReportIds = (reports) => reports.filter((r) => r.status !== 'removed').map((r) => r.id);
export const dutyItemToDb = (dutyItem) => {
    var _a, _b;
    const c = ++counter;
    const [commandName, inputType] = dutyItem._version
        ? ['updateDutyItem', 'UpdateDutyItemInput']
        : ['createDutyItem', 'CreateDutyItemInput'];
    const { mutationName, inputKey, query } = getStandardSyncerFields(commandName, c, `${dutyItemItemFields} reports { items { id status } }`);
    if (!dutyItem.userId) {
        throw new Error('Duty Item does not have userId');
    }
    const input = {
        id: dutyItem.id,
        userId: dutyItem.userId,
        state: dutyItem.state,
        deleted: dutyItem.deleted,
        type: dutyItem.type,
        startDate: dutyItem.startDate.toISOString(),
        endDate: dutyItem.endDate.toISOString(),
        forceRestAfter: dutyItem.forceRestAfter,
        sectorCount: dutyItem.sectorCount,
        startPlaceIcao: ((_a = dutyItem.startPlaceIcao) === null || _a === void 0 ? void 0 : _a.length) ? dutyItem.startPlaceIcao : null,
        endPlaceIcao: dutyItem.endPlaceIcao.length ? dutyItem.endPlaceIcao : null,
        flightLegIds: dutyItem.flightLegIds.length ? dutyItem.flightLegIds : null,
        logbookRecordIds: dutyItem.logbookRecordIds.length ? dutyItem.logbookRecordIds : null,
        note: dutyItem.note || null,
        blockTimeMinutes: dutyItem.blockTimeMinutes,
        plannedFdpExtension: dutyItem.plannedFdpExtension,
        travelToAccommodationMinutes: (_b = dutyItem.travelToAccommodationMinutes) !== null && _b !== void 0 ? _b : null,
        _version: dutyItem._version,
    };
    return {
        query,
        input,
        inputKey,
        inputType,
        mutationName,
        remoteToLocalTransform: dutyItemTransform,
        queryName: 'getDutyItem',
    };
};
export const dutyItemTransform = (input) => {
    var _a, _b;
    const reports = (_a = input.reports) === null || _a === void 0 ? void 0 : _a.items;
    return {
        id: input.id,
        type: input.type,
        state: input.state,
        userId: input.userId,
        crewId: input.crewId ? input.crewId : input.userId,
        startDate: new Date(input.startDate),
        endDate: new Date(input.endDate),
        sectorCount: input.sectorCount || 0,
        forceRestAfter: input.forceRestAfter || false,
        startPlaceIcao: input.startPlaceIcao,
        endPlaceIcao: input.endPlaceIcao || '',
        flightLegIds: input.flightLegIds || [],
        logbookRecordIds: input.logbookRecordIds || [],
        linkedDutyItemIds: input.linkedDutyItemIds || [],
        blockTimeMinutes: input.blockTimeMinutes || undefined,
        note: input.note || null,
        _version: input._version || undefined,
        deleted: input.deleted,
        editableByUserIds: input.editableByUserIds || [],
        plannedFdpExtension: input.plannedFdpExtension || false,
        travelToAccommodationMinutes: (_b = input.travelToAccommodationMinutes) !== null && _b !== void 0 ? _b : null,
        reportIds: reports && attachedReportIds(reports),
    };
};
//# sourceMappingURL=dutyItemTransformers.js.map